import styles from './Certificates.module.css'
import PciDssCert from './pci-dss.svg?react'
import MirAcceptCert from './mir-accept.svg?react'
import VerifiedByVisaCert from './verified-by-visa.svg?react'
import MastercardSecureCodeCert from './mastercard-secure-code.svg?react'

/**
 * Payment-system and security badges shown under the pay button. Purely
 * decorative, so the row is hidden from assistive tech.
 */
export function Certificates({className = ''}) {
  return (
    <div
      className={`${styles.container} ${className}`.trim()}
      aria-hidden="true"
    >
      <PciDssCert/>
      <MirAcceptCert/>
      <VerifiedByVisaCert/>
      <MastercardSecureCodeCert/>
    </div>
  )
}
